module.exports = __webpack_public_path__ + "img/145.28be4b06.png";